import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { vatTuColumn } from 'src/app/modules/phan-he-kham-benh/constants/Columns';
import ListDonThuoc from 'src/app/modules/phan-he-kham-benh/tabs/tab-thuoc/components/table-don-thuoc/TableDonThuoc';
import ThongTinPhieu from 'src/app/modules/phan-he-kham-benh/tabs/tab-thuoc/components/thong-tin-phieu/ThongTinPhieu';
import { getDetailPhieuThuocVatTu } from 'src/app/modules/phan-he-noi-tru/services/HanhChinhServices';
import { RESPONSE_MESSAGE } from 'src/app/modules/utils/Constant';
import { LOAI_BENH_AN } from 'src/app/modules/phan-he-kham-benh/constants/BenhAn';
import { useBenhAnContext } from 'src/app/modules/phan-he-kham-benh/contexts/BenhAnContext';

const PhieuVatTu = () => {
	const { phieuBenhAn } = useBenhAnContext();

	const [data, setData] = useState<any>([]);

	useEffect(() => {
		if (LOAI_BENH_AN.VAT_TU === phieuBenhAn?.displayCode) {
			getDetailPhieu();
		}
	}, [phieuBenhAn?.id, phieuBenhAn?.displayCode]);

	const getDetailPhieu = async () => {
		try {
			const { data } = await getDetailPhieuThuocVatTu(phieuBenhAn?.id);

			setData({
				...phieuBenhAn,
				terms: data.data.map((row: any) => ({
					...row,
					maVatTu: row.medicalItemCode,
					tenVatTu: row.name,
					donVi: row.unit,
					soLuong: row.totalQuantity,
					donGia: row.unitPrice,
					thanhTien: row.intoMoney,
				})),
			});
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		}
	};

	return (
		<div className="spaces p-10">
			<ThongTinPhieu thongTinPhieu={data} />
			<ListDonThuoc data={data?.terms || []} columns={vatTuColumn} />
		</div>
	);
};

export default PhieuVatTu;
